import { render } from "./AreasSection.vue?vue&type=template&id=4bb40528&scoped=true"
import script from "./AreasSection.vue?vue&type=script&lang=js"
export * from "./AreasSection.vue?vue&type=script&lang=js"

import "./AreasSection.vue?vue&type=style&index=0&id=4bb40528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb40528"]])

export default __exports__